// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__3lRXh","header":"MergedInvoice_header__1vspr"};